import styles from "./whyChooseQrhubCardV2.module.scss";
import { svgImages } from "@/lib/svgImages";
import Popup from "../popup/popup";
import { useState } from "react";

const WhyChooseQrhubCardV2 = ({
  title,
  subtitle,
  shortDesc,
  description,
  icon,
  featurePage,
  comingSoon,
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div
      className={`${styles["whyChooseQrhubCard"]}  ${
        featurePage ? styles["featurePage"] : ""
      }`}
    >
      <div
        onClick={handleOpen}
        className={`${styles["whyChooseQrhubCardContainer"]} ${
          featurePage ? styles["featurePage"] : ""
        }`}
      >
        <div className={`${styles["iconContainer"]}`}>
          <div
            className={`${styles["icon"]}`}
            dangerouslySetInnerHTML={{ __html: icon }}
          />
          {comingSoon && (
            <div className={`${styles["comingSoon"]}`}>
              <div className={`${styles["comingSoonText"]}`}>Soon</div>
            </div>
          )}
        </div>
        <div className={`${styles["text"]}`}>
          <h2
            className={`${styles["title"]} font-size-48`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            className={`${styles["description"]} font-size-18`}
            dangerouslySetInnerHTML={{ __html: shortDesc }}
          />
        </div>

        <div className={`${styles["buttonContainer"]}`}>
          <div className={`${styles["button"]}`}>
            <span dangerouslySetInnerHTML={{ __html: svgImages.arrowRight }} />
          </div>
        </div>
      </div>
      <Popup
        title={title.replace(/<br\s*\/?>/g, "")}
        subtitle={subtitle}
        content={description}
        icon={icon}
        setOpenCard={setOpen}
        openCard={open}
      />
    </div>
  );
};

export default WhyChooseQrhubCardV2;
